<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="periodLossItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :periodLoss="periodLoss"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :periodLoss="periodLoss"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :periodLoss="periodLoss"
        :isEdit="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Variedade", align: "left", sortable: true, value: "variety.title" },
        { text: "Quantidade", align: "left", sortable: true, value: "quantity" },
        { text: "Unidade", align: "left", sortable: true, value: "unit.name" },
        // { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "R$ Total", align: "left", sortable: true, value: "totalPrice" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        // { field: 'price', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    periodLossItems: { 
      type: Array,
      default: () => []
    },
    periodLoss: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Item de Perda"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Perda"
    },
  },
  created() {
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.periodLossItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
